<template>
  <div class="google-map" :id="mapName"></div>
</template>

<script>
import GoogleMapsLoader from 'google-maps'
import Driver from '../../assets/js/libs/Driver'
import { cookies } from '@/utils/cookies'
import { ApiKey } from '../../assets/js/libs/GoogleAPI'

var driver = new Driver()
export default {
  name: 'google-map',
  props: ['name', 'inputAddress', 'inputLatitude', 'inputLongitude', 'size'],
  data: function () {
    return {
      mapName: this.name + '-map',
      marker: null,
      taxiMaker: null,
      map: null,
      geocoder: null,
      clickGeoInfo: {
        address: null,
        latitude: null,
        longitude: null,
      },
      inputLat: this.inputLatitude,
      inputLng: this.inputLongitude,
      driver_markers: [],
      MarkerClusterer: null,
      count: 1,
    }
  },
  mounted: function () {
    this.initialMap()
  },
  methods: {
    initialMap() {
      let lat = cookies.get('GladAddressGps').coordinates[1]
      let lng = cookies.get('GladAddressGps').coordinates[0]
      GoogleMapsLoader.KEY = ApiKey()
      GoogleMapsLoader.load((google) => {
        const element = document.getElementById(this.mapName)
        const options = {
          zoom: this.size,
          streetViewControl: false,
          center: { lat: parseFloat(lat), lng: parseFloat(lng) },
          gestureHandling: 'greedy', //不需按ctrl就可以縮放地圖大小
        }
        this.map = new google.maps.Map(element, options)
        this.geocoder = new google.maps.Geocoder()
        this.addListenerInMap(this.geocoder)
      })
    },
    loadingLoop(markerList) {
      setTimeout(() => {
        let forMax = Math.ceil(markerList.length / 2000)
        let array = []
        if (this.count === forMax) {
          let i = (this.count - 1) * 2000
          array = markerList.slice(i, markerList.length)
        } else {
          let i = (this.count - 1) * 2000
          let j = this.count * 2000
          array = markerList.slice(i, j)
        }
        this.setMutipleMarker(array)
        this.count++
        if (this.count <= forMax) {
          this.loadingLoop(markerList)
        }
      }, 500)
    },
    setMutipleMarker(markerList) {
      let marker = null
      var forEachIt = markerList.forEach((item, index, array) => {
        marker = new google.maps.Marker({
          position: {
            lat: item.addressGPS.coordinates[1],
            lng: item.addressGPS.coordinates[0],
          },
          label: item.name,
          map: this.map,
        })
        marker.addListener(
          'click',
          ((marker, item) => {
            return () => {
              this.map.setCenter({
                lat: markerList[item].addressGPS.coordinates[1],
                lng: markerList[item].addressGPS.coordinates[0],
              })
              markerList[item].showCreate = true
              this.map.setZoom(this.map.getZoom())
              this.$emit('landmarkInfo', markerList[item])
            }
          })(marker, index),
        )
        this.driver_markers.push(marker)
      })
      this.markerCluster = new MarkerClusterer(this.map, this.driver_markers, {
        imagePath:
          'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
      })
    },
    clearMarkerMutiple() {
      for (var i = 0; i < this.driver_markers.length; i++) {
        this.driver_markers[i].setMap(null)
      }
      this.driver_markers = []
    },
    setFouceMarker(lat, lng) {
      var myLatLng = { lat: lat, lng: lng }
      this.map.panTo(myLatLng)
    },
    addListenerInMap(geocoder) {
      // 點選map上任一個點，將會出現marker,點選下一個的時候marker將會跳到下一個
      // 這function會被不斷呼叫，因為使用者點了滑鼠
      this.map.addListener('click', (e) => {
        this.setMarker(e.latLng)
        this.setlatlng(e.latLng.lat(), e.latLng.lng())
        geocoder.geocode({ location: e.latLng }, (results, status) => {
          if (status === 'OK') {
            this.setAddress(results[0])
            this.getData(results[0])
          } else {
            alert(
              'Geocode was not successful for the following reason: ' + status,
            )
          }
        })
      })
    },
    getData(val) {
      this.$emit('deliveryGPSData', val)
    },
    setAddress(val) {
      //  console.log(val)
      let removedAddressKey = val.formatted_address
        .trim()
        .replace(/\s/, '')
        .replace(/^\d+/, '')
      if (removedAddressKey.slice(0, 2) === '台灣') {
        removedAddressKey = removedAddressKey.slice(2, removedAddressKey.length)
      }
      // console.log(removedAddressKey)
      this.clickGeoInfo.address = removedAddressKey
      this.$emit('clickAddress', this.clickGeoInfo)
    },
    setlatlng(lat, lng) {
      // console.log("===>", lat+ lng)
      this.clickGeoInfo.latitude = lat
      this.clickGeoInfo.longitude = lng
    },
    setLatLng(lat, lng) {
      var myLatLng = { lat: lat, lng: lng }
      this.setMarker(myLatLng)
    },
    setMarker(latlng) {
      if (this.marker === null) {
        this.marker = new google.maps.Marker({
          position: latlng,
          map: this.map,
        })
        this.map.panTo(latlng)
      } else {
        this.marker.setMap(null)
        this.marker = null
        if (this.marker === null) {
          this.marker = new google.maps.Marker({
            position: latlng,
            map: this.map,
          })
          this.map.panTo(latlng)
        }
      }
    },
    setDriverMarkers(data) {
      // console.log(data.result)
      this.refreshDriverMarker()
      if (data.result !== '無車輛') {
        data.result.forEach((driver_info) => {
          var marker = new google.maps.Marker({
            position: {
              lat: driver_info.point[1],
              lng: driver_info.point[0],
            },
            map: this.map,
            icon: new google.maps.MarkerImage(driver.getFormatStatus(1).img),
          })
          this.driver_markers.push(marker)
        })
      }
    },
    refreshDriverMarker() {
      if (this.driver_markers.length !== 0) {
        this.driver_markers.forEach((markers) => {
          markers.setMap(null)
        })
      }
    },
    clearData() {
      this.refreshDriverMarker()
      if (this.marker !== null) {
        this.marker.setMap(null)
      }
    },
    clearSelfLandmarkData() {
      if (this.marker !== null) {
        this.marker.setMap(null)
      }
    },
  },
  computed: {},
}
</script>

<style scoped>
.google-map {
  /* width: 800px; */
  /* height: 600px; */
  margin: 0 left;
  background: gray;
}
</style>



// WEBPACK FOOTER //
// src/pages/mapComponent/Map.vue